<template>
    <div class="cc-payment-form">
        <div class="row">
            <div class="col-md-5 col-12 pb-2 pb-md-0">
                <div class="credit-card-wrapper"></div>
            </div>
            <div class="col-md-7 col-12 p-0 d-flex align-items-center">
                <form @submit.prevent="submit($event)" id="cc-form" class="row m-0 p-0">
                    <div class="row m-0 p-0">
                        <div class="col-md-12 mb-3">
                            <input 
                                data-vv-as="nome do portador" 
                                :class="{'input': true, 'is-invalid': errors.has('cc-name') }"
                                name="cc-name" 
                                v-validate="'required'"
                                type="text"
                                class="form-control"
                                v-model="card.name"
                                id="cc-name"
                                :placeholder="$t('Nome do portador')"
                                value=""
                            >
                            <div class="invalid-feedback">
                                {{ errors.first('cc-name') }}
                            </div>
                        </div>
                    </div>
                    <div class="row m-0 p-0">
                        <div class="col-md-12 mb-3">
                            <input 
                                data-vv-as="número do cartão" 
                                :class="{'input': true, 'is-invalid': errors.has('cc-number') }"
                                name="cc-number" 
                                v-validate="'required'"
                                type="text"
                                class="form-control"
                                v-model="card.number"
                                id="cc-number"
                                :placeholder="$t('Número do cartão')"
                                value=""
                            >
                            <div class="invalid-feedback">
                                {{ errors.first('cc-number') }}
                            </div>
                        </div>
                    </div>
                    <div class="row m-0 p-0">
                        <div class="col-md-6 mb-3">
                            <masked-input 
                                data-vv-as="data de validade" 
                                :class="{'input': true, 'is-invalid': errors.has('cc-expiration') }"
                                name="cc-expiration" 
                                v-validate="'required'"
                                type="text"
                                class="form-control"
                                v-model="card.expiration"
                                id="cc-expiration"
                                :placeholder="$t('Data de validade (MM/AAAA)')"
                                value=""
                                :mask="[/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                            />
                            <div class="invalid-feedback">
                                {{ errors.first('cc-expiration') }}
                            </div>
                        </div>
                        <div class="col-md-6 mb-3">
                            <input 
                                data-vv-as="código de segurança" 
                                :class="{'input': true, 'is-invalid': errors.has('cc-cvv') }"
                                name="cc-cvv" 
                                v-validate="'required'"
                                type="text"
                                class="form-control"
                                v-model="card.cvv"
                                id="cc-cvv"
                                :placeholder="$t('CVV')"
                                value=""
                            >
                            <div class="invalid-feedback">
                                {{ errors.first('cc-cvv') }}
                            </div>
                        </div>
                    </div>
                    <div class="row m-0 p-0 justify-content-end">
                        <div class="col-md-3 col-6">
                            <button v-if="!loading" class="form-control btn btn-dark" type="button" @click="cancel"> {{ $t('Voltar') }} </button>
                        </div>
                        <div class="col-md-3 col-6">
                            <button v-if="!loading" class="form-control btn btn-primary" type="submit" :disabled="finished"> PAGAR </button>
                            <button v-else class="form-control btn btn-disabled d-flex justify-content-center align-items-center" type="button" disabled>
                                <div class="spinner-border text-dark" role="status"></div>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    computed: {
        locale() {
            return window.locale.replace('_', '-')
        },
    },
    data() {
        return {
            finished: false,
            card : {
                number : '',
                name : '',
                expiration : '',
                cvv : '',
                brand: '',
                installments: 0,
            },
            cardForm: undefined,
            acceptedBrands: [
                'amex',
                'dinersclub',
                'discover',
                'jcb',
                'mastercard',
                'visa',
                'elo',
                'hipercard',
            ],
        }
    },
    props: {
        cart: {
            required: true,
            type: Object,
        },
        installments: {
            required: true,
            type: Array,
        },
        products: {
            required: true,
            type: Array,
        },
        loading: {
            default: false,
            type: Boolean
        },
        config: {
            required: true,
            type: Object,
        },
    },
    mounted() {
        this.cardForm = new Card({
            form: document.querySelector('#cc-form'),
            container: '.credit-card-wrapper',
            formSelectors: {
                numberInput: 'input#cc-number',
                nameInput: 'input#cc-name',
                expiryInput: 'input#cc-expiration',
                cvcInput: 'input#cc-cvv',
            },
            placeholders: {
                name: 'Fulano da Silva'
            },
            messages: {
                monthYear: 'mm/aaaa'
            }
        });
        this.cardForm.$cardContainer[0].style.maxWidth = '315px';
    },
    methods: {
        async submit($event) {
            const form = document.getElementById("cc-form")

            $event.preventDefault()
            $event.stopPropagation()

            form.classList.remove('was-validated')

            try {
                const expiration = window.luxon.fromFormat(this.card.expiration, 'MM/yyyy')

                if (!expiration.isValid) {
                    throw "Data de expiração inválida."
                } 
            } catch (error) {
                this.$emit('error', "Data de expiração inválida, favor utilizar o formato MM/AAAA.")
                return
            }

            let encrypted = undefined

            try {
                const pkey = this.config !== undefined ? this.config.payment.creditcard.extra_fields.public_key : '';
                
                encrypted = PagSeguro.encryptCard({
                    publicKey: pkey,
                    holder: this.card.name,
                    number: this.card.number,
                    expMonth: this.card.expiration.split('/')[0],
                    expYear: this.card.expiration.split('/')[1],
                    securityCode: this.card.cvv
                });
            } catch (error) {
                console.log(error)
            }

            if (!await this.$validator.validate()) return;
            
            this.card.brand = this.cardForm.cardType
            if (encrypted.encryptedCard) {
                this.card.token = encrypted.encryptedCard
            }

            this.pay()
            form.classList.add('was-validated')
        },
        async pay() {
            try {
                this.loading = true

                const card = this.card
                this.card.number = card.number.replaceAll(' ', '')
                this.card.expiration = card.expiration.replaceAll(' / ', '/')
                this.card.brand = this.getCardBrand()

                const token = await window.generateRecaptchaToken();
                
                const response = await axios.post('/api/payment/sign', {
                    cart: this.cart,
                    card: card,
                    type: 'recorrente',
                    products: this.products,
                    token: token,
                });
                
                this.order = response.data.order

                this.finished = true

                this.$emit('submit', response.data.order)
            } catch (error) {
                console.log(error)
                this.$emit('error', error.response.data.message ?? error.response.data.error)
                this.loading = false
            }
        },
        cancel() {
            this.$emit('close')
        },
        getCardBrand() {
            const cards = {
                'amex': 'Amex',
                'dinersclub': 'Diners',
                'discover': 'Discover',
                'jcb': 'JCB',
                'mastercard': 'master',
                'visa': 'Visa',
                'elo': 'Elo',
                'hipercard': 'Hiper' 
            }

            return cards[this.card.brand] ?? 'master'
        },
    }
});
</script>

<style scoped>
    .credit-card-wrapper {
        flex-grow: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .spinner-border {
        height: 1rem;
        width: 1rem;
    }

    .jp-card-container {
        width: 100% !important;
        height: 100% !important;
    }

    .pr-0 {
        padding-right: 0;
    }
</style>
